<template>
	<div>
		<v-layout row mt-2 ml-4 v-if="data.selected.length > 0">
			<div>
				<strong>Grupy docelowe:</strong> {{beneficiariesNames}}
			</div>
		</v-layout>
		<v-expand-transition>
			<v-layout row mt-2 ml-4 v-show="data.otherBeneficiaryEnabled">
				<div>
					<strong>Nazwa innej grupy docelowej:</strong> {{data.otherBeneficiary}}
				</div>
			</v-layout>
		</v-expand-transition>
	</div>
</template>

<script>
	import {Beneficiary} from "../../../../api/generated/Beneficiary";
	import {createLabels} from "../../../../utils/createLabels";

	export default {
		name: "ProjectChooseBeneficiariesReadOnlyView",
		methods: {
			getContestId () {
				return this.contestId;
			},
		},

		computed: {
			beneficiariesNames () {
				let names = [];
				for (let itemId of this.data.selected) {
					let found = this.options.find(item => item.id === itemId);
					if (found) names.push(found.name);
				}
				return names.join(', ');
			}
		},

		mounted () {
			Beneficiary.getAllBeneficiaries(
				this,
				this.getContestId(),
				response => {
					this.options = response;
				},
			);

		},

		updated () {
			createLabels.addAriaLabelForInputWithRole("checkbox");
		},


		data () {
			return {
				data: {
					contestId: null,
					selected: [],
					otherBeneficiary: "",
					otherBeneficiaryEnabled: false,
				},
				options: [],

			};
		},

		watch: {
			value: {
				immediate: true,
				handler (val) {
					if (val === undefined) {
						return;
					}
					this.data.otherBeneficiary = val.otherBeneficiary;
					this.data.otherBeneficiaryEnabled = val.otherBeneficiaryEnabled;
					if (this.data.otherBeneficiaryEnabled === undefined) {
						this.data.otherBeneficiaryEnabled = (val.otherBeneficiary !== null && val.otherBeneficiary !== undefined && val.otherBeneficiary !== '');
					}
					this.data.selected = val.selected;
				},
			},
		},

		props: {
			value: {},
			contestId: null,
		},
	};
</script>